import React from 'react';
import { ArrowLeft, Menu, MessageCircle, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getPublicMenuPath } from '@/lib/tenant/getPublicMenuPath';

/** Barra superior mínima: volver + acciones de carrito (sin banner del asistente). */
export function AssistantHeader({
  navigate,
  routeBid,
  primaryColor,
  cartCount,
  onOpenCheckout,
  onBrowseProducts,
}) {
  return (
    <div className="shrink-0 z-40 bg-background/95 backdrop-blur border-b">
      <div className="max-w-4xl mx-auto px-4 py-2.5 flex items-center justify-between gap-2">
        <Button
          variant="ghost"
          onClick={() => navigate(getPublicMenuPath(routeBid, 'home'))}
          data-testid="back-button"
          className="shrink-0"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Volver
        </Button>

        <div className="flex justify-end shrink-0 items-center gap-1.5">
          {cartCount > 0 ? (
            <div className="flex flex-wrap items-center justify-end gap-1 max-w-[min(100%,14rem)] sm:max-w-none">
              <Button
                variant="default"
                size="sm"
                className="h-9 px-2 sm:px-2.5 text-white shrink-0"
                style={{ backgroundColor: primaryColor }}
                onClick={onOpenCheckout}
                data-testid="assistant-header-checkout-chat"
                title="Terminar pedido en el chat (datos y pago)"
              >
                <MessageCircle className="w-4 h-4 sm:mr-1" />
                <span className="hidden sm:inline">Terminar pedido</span>
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="shrink-0"
                onClick={onBrowseProducts}
                data-testid="assistant-header-cart"
                title="Agregar productos desde el chat"
              >
                <Plus className="w-4 h-4 sm:mr-1" />
                <span className="hidden sm:inline">Agregar más</span>
              </Button>
            </div>
          ) : (
            <Button
              variant="ghost"
              size="sm"
              onClick={onBrowseProducts}
              data-testid="assistant-header-menu"
              title="Elegir productos en el asistente"
            >
              <Menu className="w-4 h-4 sm:mr-1" />
              <span className="hidden sm:inline">Elegir</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
